import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSettings } from '../../../redux/actions';
import { patientDetailsStyles } from '../../../theme/style';

export default function Goal({ goal, handleChangeGoal, compilance, hasAccess }) {
  const distpatch = useDispatch();
  const { patient } = useSelector((state) => state.user);

  console.log(patient.personalInfo);
  const updateGoal = () => {
    if (goal != compilance) {
      distpatch(
        setSettings(patient.personalInfo.id, {
          serial_number: null,
          compliance_hours: goal + '',
        }),
      );
    }
  };
  return (
    <div>
      <div style={patientDetailsStyles.startDate}>Brace wear goal &nbsp;</div>

      <div className="row" style={{ alignItems: 'center' }}>
        <div
          style={styles.buttonScroll}
          onClick={() => {
            goal > 1 ? handleChangeGoal(Number(goal)-1) : handleChangeGoal(1);
          }}
        >
          {'<'}
        </div>
        {goal >= 1 ? goal : 1}
        <div
          style={styles.buttonScroll}
          onClick={() => {
            handleChangeGoal(Number(goal) + 1);
          }}
        >
          {'>'}
        </div>
      </div>
      {hasAccess() && (
        <div style={goal != compilance ? styles.button : styles.buttonDisabled} onClick={updateGoal}>
          Update Goal
        </div>
      )}
    </div>
  );
}

const styles = {
  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonDisabled: {
    cursor: 'pointer',
    backgroundColor: '#9f9f9f',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  button: {
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};
